import styled from 'styled-components';

export const GalleryContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  margin-top: 1rem;
  overflow: auto;
`;

export const MainImageContainer = styled.div`
  position: relative;
  aspect-ratio: 1;
  border-radius: 0.5rem;
  border: 1px solid #e5e7eb;
  overflow: hidden;
  width: 80%;
  max-width: 500px;
  margin: 0 auto;

  @media (min-width: 768px) {
    width: 100%;
    margin: 0;
  }
`;

export const MainImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ThumbnailsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  overflow-y: auto;
  max-height: 500px;
`;

export const ThumbnailButton = styled.div`
  width: 60px;
  height: 60px;
  position: relative;
  border-radius: 0.375rem;
  border: 1px solid #e5e7eb;
  overflow: hidden;
  padding: 0;
  cursor: pointer;
  ${(props) =>
    props.selected &&
    `
    border: 2px solid #3b82f6;
  `}
`;

export const ThumbnailImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const DeleteButton = styled.button`
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
  background-color: #ef4444;
  color: white;
  border: none;
  border-radius: 9999px;
  width: 12px;
  height: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }
`;
